document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.makeup-dropdown');

  dropdowns.forEach(dropdown => {
    const button = dropdown.querySelector('.makeup-dropdown-button');
    const content = dropdown.querySelector('.makeup-dropdown-content');
    const options = dropdown.querySelectorAll('.makeup-dropdown-option');
    const buttonText = dropdown.querySelector('.makeup-dropdown-button-text');
    const buttonImage = buttonText.querySelector('img');
    const buttonTextValue = buttonText.querySelector('.makeup-dropdown-button-text-value');

    // Initialize state - hide image if no selection
    if (!buttonTextValue.textContent.includes('|')) {
      buttonText.classList.remove('has-selection');
    }

    // Toggle dropdown
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      const isActive = dropdown.classList.contains('active');
      
      // Close all other dropdowns
      dropdowns.forEach(d => d.classList.remove('active'));
      
      // Toggle current dropdown
      if (!isActive) {
        dropdown.classList.add('active');
      }
    });

    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', () => {
        const optionImg = option.querySelector('img');
        const optionText = option.querySelector('.makeup-dropdown-option-text');
        // Get the original option value from data attribute, not from display text
        const optionValue = option.dataset.optionValue || optionText.textContent.split('|')[0].trim();
        
        // Find and trigger the corresponding makeup-option label using the original value
        const parentField = dropdown.closest('.makeup-options-fields');
        const makeupOptions = parentField.querySelector('.makeup-options');
        const correspondingLabel = makeupOptions.querySelector(`label[data-value="${optionValue}"]`);
        
        if (correspondingLabel) {
          correspondingLabel.click();
        }

        // Update button content with display text
        buttonImage.src = optionImg.src;
        buttonTextValue.textContent = optionText.textContent;
        buttonText.classList.add('has-selection');
        
        // Close dropdown
        dropdown.classList.remove('active');
      });
    });

    // Listen for makeup-option deselection
    const parentField = dropdown.closest('.makeup-options-fields');
    if (parentField) {
      const makeupOptions = parentField.querySelector('.makeup-options');
      if (makeupOptions) {
        const radioInputs = makeupOptions.querySelectorAll('input[type="radio"]');
        radioInputs.forEach(input => {
          input.addEventListener('change', () => {
            if (!input.checked) {
              // Reset dropdown when option is deselected
              buttonImage.src = '';
              const subparentLabel = parentField.querySelector('.makeup-subparent-label').textContent;
              buttonTextValue.textContent = `Select ${subparentLabel} option.`;
              buttonText.classList.remove('has-selection');
            }
          });
        });
      }
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.makeup-dropdown')) {
      dropdowns.forEach(dropdown => dropdown.classList.remove('active'));
    }
  });
}); 